import { useQuery } from "@tanstack/react-query";
import useApi from "../utils/useApi";

export default function useEventsLastChange({ enabled = true }) {
  const { getEventsLastChange } = useApi();

  const { data, isLoading, error } = useQuery({
    queryKey: ["eventsLastChange"],
    queryFn: getEventsLastChange,
    enabled,
  });

  return { data: data?.data, isLoading, error };
}
